import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'

import Vue from 'vue'
import './uni.promisify.adaptor'

import store from './store/index.js'
Vue.prototype.$store = store;

import uView from "uview-ui";
Vue.use(uView); 

Vue.config.productionTip = false;
App.mpType = 'app';

Vue.prototype.$onLaunched = new Promise(resolve => {
	Vue.prototype.$isResolve = resolve;
})

// Vue.prototype.$baseUrl = 'https://test.doumee.cn/bikeWeb/'
// Vue.prototype.$baseUrl = 'http://192.168.0.3/bikeWeb/'
// Vue.prototype.$baseUrl = 'http://192.168.1.23:10025/'
Vue.prototype.$baseUrl = 'https://bikes.yxbhlt.cn/bike_h5_api/'
// Vue.prototype.$baseUrl = 'https://dmtest.ahapp.net/bike_h5_api/'
// Vue.prototype.$baseUrl = 'http://xiaopiqiu2.natapp1.cc/'
// Vue.prototype.$baseUrl = 'http://xiaopiqiu.natapp1.cc/'
// Vue.prototype.$baseUrl = 'http://xiaopiqiu3.natapp1.cc/'

store.dispatch('getHeight')

const app = new Vue({
	store,
	...App
})

// http接口API抽离
import httpApi from '@/utils/http.api.js'
Vue.use(httpApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()